import { render, staticRenderFns } from "./ScrumBoard.vue?vue&type=template&id=1cd844c8&"
import script from "./ScrumBoard.vue?vue&type=script&lang=js&"
export * from "./ScrumBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports